import React from 'react';
import { InputDropdownStyled } from './styled';
import cx from 'classnames';

export const InputDropdown = (props) => {
  const { theme_standard,theme_full, options, input } = props;
  const customClass = cx({
    theme_standard: theme_standard,
    theme_full:theme_full
  });

  return (
    <InputDropdownStyled>
      <div className={customClass}>
        <select {...input} className='select_box'>
          <option value="">กรุณาเลือกข้อมูล</option>
          {options &&
            options.map((e, i) => (
              <option key={i} className="option_wrap" value={e.value}>
                {e.label}
              </option>
            ))}
        </select>
      </div>
    </InputDropdownStyled>
  );
};
